<div class="activity-report-filter">

  <div class="row">
    <div class="col-sm-4" style="margin-top: 20px;">
      <p-button 
        styleClass="custom-save-button" 
        (click)="hideFilter=!hideFilter"  
        [raised]="true"
        label="{{(!hideFilter ? 'COMPONENTS.HideFilter':'COMPONENTS.ShowFilter') | translate}}"
        icon="{{!hideFilter ? 'pi pi-chevron-circle-up':'pi pi-chevron-circle-down'}}" 
        iconPos="right">
      </p-button>
    </div>
    <div class="col-sm-8">
      <div style="display: flex; flex-direction: row; justify-content: flex-end;">
        <div class="col-sm-3 gap">
          <label>{{'COMPONENTS.GroupBy' | translate}}</label>
          <p-select [options]="groupByData" [(ngModel)]="defaultValue" [style]="{'width':'100%'}" showClear="true"
            (onChange)="applyGroupBy($event)">
          </p-select>
        </div>
        <div style="margin-top: 25px;">
          <p-button  (click)="collapseAll()" [raised]="true" class="ui-button-rounded"
            label="{{(!expanded ? 'COMPONENTS.ExpandAll':'COMPONENTS.CollapseAll') | translate}}"
            icon="{{!expanded ? 'pi pi-chevron-circle-down':'pi pi-chevron-circle-up'}}" iconPos="right"
            *ngIf="showCollapse">
          </p-button>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!hideFilter">
    <div class="row">
      <div class="col-sm-2">
        <label>{{'COMPONENTS.EquipmentClass' | translate}}</label>
        <p-multiSelect [options]="WBSCategoryFilterData" [(ngModel)]="selectedWBSCategoryFilter" optionLabel="Name"
          [style]="{'width':'100%'}" [filter]="true">
        </p-multiSelect>
      </div>
      <div class="col-sm-2">
        <label>{{'COMPONENTS.Job' | translate}}</label>
        <p-multiSelect [options]="WBSFilterData" [(ngModel)]="selectedWBSFilter" optionLabel="Name"
          [style]="{'width':'100%'}" [filter]="true"></p-multiSelect>
      </div>
      <div class="col-sm-2">
        <label>{{'COMPONENTS.Crew' | translate}}</label>
        <p-multiSelect [options]="crewFilterData" [(ngModel)]="selectedcrewFilter" optionLabel="Name"
          [style]="{'width':'100%'}" [filter]="true"></p-multiSelect>
      </div>
      <div class="col-sm-2">
        <label>{{'COMPONENTS.Status' | translate}}</label>
        <p-multiSelect [options]="statusFilterData" [(ngModel)]="selectedstatusFilter" [style]="{'width':'100%'}"
          [filter]="true"></p-multiSelect>
      </div>
    </div>
    <div class="row">
      <div style="float: right;">
        <p-button class="margin" [raised]="true" severity="danger" (click)="clearFilters()">
          <span>{{'COMPONENTS.Clear' | translate}}</span>
        </p-button>
        <p-button class="margin"  [raised]="true" severity="success" (click)="applyFilters()">
          <span>{{'COMPONENTS.Apply' | translate}}</span>
        </p-button>
      </div>
    </div>
  </div>
</div>
